import React from 'react';
import PublicNavbar from '../components/layout/PublicNavbar';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicNavbar />
      <div className="pt-24 pb-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">About DynPro Alumni</h1>
            
            <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Mission</h2>
              <p className="text-gray-600 mb-6">
                At DynPro Alumni, we're dedicated to fostering a vibrant community of professionals who share a common background in dynamic programming. Our platform serves as a bridge between alumni, current students, and industry opportunities.
              </p>
              
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">What We Do</h2>
              <p className="text-gray-600 mb-6">
                We provide a comprehensive platform for alumni to:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
                <li>Connect with fellow alumni and industry professionals</li>
                <li>Access exclusive career opportunities</li>
                <li>Participate in mentorship programs</li>
                <li>Stay updated with industry trends and developments</li>
                <li>Contribute to the growth of the programming community</li>
              </ul>
              
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Impact</h2>
              <p className="text-gray-600 mb-6">
                Since our inception, we've helped thousands of alumni connect, grow, and succeed in their professional journeys. Our community spans across various industries, bringing together diverse perspectives and experiences.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Join Our Community</h2>
              <p className="text-gray-600 mb-6">
                Whether you're a recent graduate or a seasoned professional, there's a place for you in our community. Join us to:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
                <li>Expand your professional network</li>
                <li>Access exclusive job opportunities</li>
                <li>Share your knowledge and experience</li>
                <li>Stay connected with your alma mater</li>
                <li>Make a difference in the programming community</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 